module.exports = __webpack_public_path__ + "img/blpad_blastpad.6464e17.png";